var map = {
	"./af.json": 7938,
	"./am.json": 5312,
	"./ar.json": 2328,
	"./az.json": 3832,
	"./be.json": 3516,
	"./bg.json": 9760,
	"./bn.json": 2052,
	"./br.json": 7088,
	"./bs.json": 2768,
	"./ca.json": 4144,
	"./cs.json": 8050,
	"./cy.json": 2968,
	"./da.json": 7680,
	"./de.json": 2492,
	"./dv.json": 9176,
	"./el.json": 7824,
	"./en.json": 5616,
	"./es.json": 1008,
	"./et.json": 7544,
	"./eu.json": 6984,
	"./fa.json": 7752,
	"./fi.json": 7596,
	"./fr.json": 7432,
	"./ga.json": 2146,
	"./gl.json": 172,
	"./ha.json": 552,
	"./he.json": 4416,
	"./hi.json": 9560,
	"./hr.json": 1144,
	"./hu.json": 6536,
	"./hy.json": 442,
	"./id.json": 4296,
	"./is.json": 6732,
	"./it.json": 660,
	"./ja.json": 4760,
	"./ka.json": 9568,
	"./kk.json": 8448,
	"./km.json": 3236,
	"./ko.json": 5184,
	"./ku.json": 6280,
	"./ky.json": 240,
	"./lt.json": 930,
	"./lv.json": 2044,
	"./mk.json": 4300,
	"./ml.json": 8136,
	"./mn.json": 2712,
	"./mr.json": 1992,
	"./ms.json": 2440,
	"./nb.json": 3720,
	"./nl.json": 651,
	"./nn.json": 5496,
	"./no.json": 9584,
	"./pl.json": 9744,
	"./ps.json": 9740,
	"./pt.json": 8338,
	"./ro.json": 6120,
	"./ru.json": 7108,
	"./sd.json": 8208,
	"./sk.json": 6136,
	"./sl.json": 2624,
	"./so.json": 5992,
	"./sq.json": 3520,
	"./sr.json": 3890,
	"./sv.json": 5272,
	"./sw.json": 3866,
	"./ta.json": 5136,
	"./tg.json": 8628,
	"./th.json": 3968,
	"./tr.json": 8404,
	"./tt.json": 5194,
	"./ug.json": 6864,
	"./uk.json": 8370,
	"./ur.json": 1136,
	"./uz.json": 3888,
	"./vi.json": 2891,
	"./zh.json": 8864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8888;